module.exports = __webpack_public_path__ + "img/video_ingredientes.6fcf4be1.png";